export default function OstroChatIcon() {
  return (
    <svg
      data-testid="ostro-chat-icon"
      className="ostro-chat-icon"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="12"
      viewBox="0 0 20 12"
      fill="none"
    >
      <path
        d="M5.59642 3.34399C4.3311 3.34399 3.44781 4.33413 3.44781 5.54726V5.56584C3.44781 6.77898 4.33924 7.78771 5.61538 7.78771C6.89152 7.78771 7.76395 6.79756 7.76395 5.58442V5.56584C7.76395 4.35271 6.87256 3.34399 5.59642 3.34399Z"
        fill="white"
      />
      <path
        d="M14.317 3.34399C13.0516 3.34399 12.1683 4.33413 12.1683 5.54726V5.56584C12.1683 6.77898 13.06 7.78771 14.3361 7.78771C15.6123 7.78771 16.4845 6.79756 16.4845 5.58442V5.56584C16.4845 4.35271 15.5931 3.34399 14.317 3.34399Z"
        fill="white"
      />
      <path
        d="M14.326 0H5.68167C2.54415 0 -1.1281e-05 2.49262 -1.1281e-05 5.5666C-1.1281e-05 8.64058 2.54415 11.1332 5.68167 11.1332H14.326C17.4635 11.1332 20.0074 8.64058 20.0074 5.5666C20.0074 2.49262 17.4635 0 14.326 0ZM9.01429 5.5666C9.01429 7.31593 7.62977 8.79717 5.67353 8.79717C3.71733 8.79717 2.34907 7.34248 2.34907 5.58518V5.5666C2.34907 3.81726 3.73357 2.336 5.68982 2.336C7.64602 2.336 9.01429 3.79071 9.01429 5.54802V5.5666ZM17.6611 5.5666C17.6611 7.31593 16.2768 8.79717 14.3204 8.79717C12.3641 8.79717 10.9958 7.34248 10.9958 5.58518V5.5666C10.9958 3.81726 12.3805 2.336 14.3368 2.336C16.2928 2.336 17.6611 3.79071 17.6611 5.54802V5.5666Z"
        fill="white"
      />
    </svg>
  );
}
